<!--
 @description dashBoard 新增
 @author huangzhijie
 @date 2018/11/19
-->
<style>

</style>

<template>
  <div class="dashboardAdd__content">
    <back :history="history"></back>
    <div>
      <el-form ref="dashboardform" 
        :model="formModel"
        :rules="formRules"
        :inline="true" 
        input-width="auto">
        <el-form-item :label="$t('dashBoard.name')" key="name" prop="name">
          <el-input v-model="formModel.name" :placeholder="$t('dashBoard.title')"></el-input>          
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="e_showList">{{ showList ? $t('dashBoard.hideList') : $t('dashBoard.showList') }}</el-button>
          <el-button type="primary" @click="e_save">{{ $t('common.save') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-collapse-transition>
      <view-list v-show="showList"
        ref="viewList"  
        :control="tableControl">
      </view-list>
    </el-collapse-transition>
    <chart-list :chart-data-list="in_chartListData" @chart-dashboard-click="e_delete"></chart-list>
  </div>
</template>
<script>
import back from '@/components/back'
import viewList from '@/views/component/view/viewList'
import chartList from '@/components/chart/chart-dashboard-list'
import validateConfig from '@/utils/validate'

export default {
  components: {
    back,
    chartList,
    viewList
  },
  data () {
    const that = this
    return {
      history: [{ name: that.$t('dashBoard.dashBoardAdd') }],
      tableControl: [{
        label: that.$t('dashBoard.push'),
        callback: that.e_add
      }],
      formModel: {
        name: ''
      },
      formRules: {
        name: [{ ...validateConfig.common.notEmpty }]
      },
      showList: true
    }
  },
  watch: {
  },
  methods: {
    resetData () {
      this.formModel.name = ''
      this.in_resetData()
    },
    e_add (row, index, data) {
      if (this.in_checkViewExist(row.id)) {
        this.$message({
          message: this.$t('dashBoard.viewRepeatTips'),
          type: 'warning'
        })
        return
      }

      this.in_addOneChartData({
        id: row.id,
        name: row.name,
        dataSource: row.dataSources,
        appName: row.extend.appName,
        group: row.extend.group,
        kpiKey: row.extend.kpiKey
      })
    },
    e_save () {
      this.$refs['dashboardform'].validate((valid) => {
        if (valid) {
          const saveData = {
            name: this.formModel.name,
            viewList: []
          }
          this.in_viewList.map((item) => {
            saveData.viewList.push(item)
          })

          this.in_save(saveData).then((d) => {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })

            this.resetData()
          })
        } else {
          return false
        }
      })
    },
    e_showList () {
      this.showList = !this.showList
    },
    e_delete (data) {
      this.in_delete(data.index)
    }
  },
  mounted () {
  }
}
</script>